import { Link } from "react-router-dom";
import LogoDesctop from "../../../../assets/icon/LogoDesctop";
import MasterCard from "../../../../assets/icon/MasterCard";
import FooterLinks from "./components/FooterLinks";

const Footer = () => {
  return (
    <div className="w-full flex justify-center">
      {/* <> */}
      <div className="w-full flex justify-center items-center md:max-w-[1000px] md:bg-white md:max-h-[15.4rem]  py-10">
        {/* <div className="flex justify-center items-center md:bg-gray md:max-h-[15.4rem] py-10"> */}
        <div className="w-full flex flex-col-reverse max-w-xl md:max-w-[1000px] justify-start items-start px-5 md:flex-row">
          <div className="min-w-[21.5rem] flex-col items-start">
            <FooterLinks />
            <div className="w-full flex justify-start items-center">
              <div className="pr-2.5">
                <Link to="/">
                  <LogoDesctop />
                </Link>
              </div>
              <div className="pl-2.5 border-l-2	border-light_gray">
                <MasterCard />
              </div>
            </div>
            <div>
              <p className="w-full pt-5 text-left">© SILPO, 2023</p>
            </div>
          </div>
          <div className="flex flex-col justify-start items-start pb-5 text-sm font-semibold md:pl-8">
            <a className="pb-3 hover:text-orange" href="/contacts">
              Контакти та зворотній звʼязок
            </a>
            <a
              className="pb-3 hover:text-orange"
              href="https://silpo.ua/polityka-konfidencijnosti"
            >
              Політика конфіденційності
            </a>
            <a
              className="pb-3 hover:text-orange"
              href="https://silpo.ua/politiki-zi-stalogo-rozvitku"
            >
              Політики компанії
            </a>
            <a
              className="pb-3 hover:text-orange"
              href="https://silpo.ua/pravyla-bezpeky"
            >
              Правила безпеки
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
